/**
 * Helperi comuni pentru exporturile .xlsx/.docx din tab-urile licitatiei.
 */

/** Trunchiaza la 2 zecimale - aceeasi regula ca afisarea din admin. */
export function truncate2(amount: number): number {
    return Math.floor((Number(amount) || 0) * 100) / 100;
}

/** Bucata de nume de fisier fara caracterele interzise de sistemele de fisiere. */
export function safeFileNamePart(value: string, fallback: string): string {
    const safe = String(value || fallback)
        .replace(/[\\/:*?"<>|]+/g, '')
        .trim()
        .replace(/\s+/g, '-');
    return safe || fallback;
}

/** "1 lot", "3 loturi" - pentru randurile de subtotal. */
export function lotsLabel(count: number): string {
    return count === 1 ? '1 lot' : `${count} loturi`;
}

/** "435/26.06.2026" - numarul contractului de depozit si data crearii. */
export function contractLabel(contract: any): string {
    if (!contract || contract.number == undefined) return '';

    const date = contract.createdAt
        ? new Date(contract.createdAt).toLocaleDateString('ro-RO', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
          })
        : '';
    return date ? `${contract.number}/${date}` : String(contract.number);
}

/**
 * Selectia din modalele de export: loturi bifabile, grupate (pe deponent,
 * pe castigator etc.).
 */
export interface SelectableLot {
    selected: boolean;
}

export interface SelectionGroup {
    lots: SelectableLot[];
}

export function groupSelectedCount(group: SelectionGroup): number {
    return ((group && group.lots) || []).filter((lot) => lot.selected).length;
}

export function isGroupFullySelected(group: SelectionGroup): boolean {
    const lots = (group && group.lots) || [];
    return lots.length > 0 && groupSelectedCount(group) === lots.length;
}

export function totalLotCount(groups: SelectionGroup[]): number {
    return (groups || []).reduce(
        (total, group) => total + group.lots.length,
        0,
    );
}

export function selectedLotCount(groups: SelectionGroup[]): number {
    return (groups || []).reduce(
        (total, group) => total + groupSelectedCount(group),
        0,
    );
}

export function setLotsSelected(lots: SelectableLot[], value: boolean): void {
    (lots || []).forEach((lot) => {
        lot.selected = value;
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/export.ts